var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-back",on:{"click":_vm.back}},[_vm._v("\n  戻る\n")])}
var staticRenderFns = []

export { render, staticRenderFns }